import React, { useState, useEffect, useRef } from 'react'
import { Map, Marker } from 'react-amap'
import { Button, message } from 'antd'

interface AmapProps {
  locateInfo: {
    address: string
  }
  handleCancel: () => void
  handleOk: (position: { longitude: number; latitude: number }, address: string) => void
}

function Amap(props: AmapProps) {
  const { locateInfo, handleCancel, handleOk } = props

  const [position, setPosition] = useState({ longitude: 116.3, latitude: 39.9246 })
  const [searchContent, setSearchContent] = useState('')
  const [zoom, setZoom] = useState(12)
  const geocoderRef = useRef<any>(null)

  useEffect(() => {
    setSearchContent(locateInfo.address)
  }, [locateInfo.address])

  const placeSearch = (e) => {
    setSearchContent(e)
  }

  const mapEvents = {
    created: (e) => {
      let auto
      let geocoder
      // 输入提示插件
      window.AMap.plugin('AMap.Autocomplete', () => {
        auto = new window.AMap.Autocomplete({ input: 'search-input' })
      })
      // 正逆地理位置
      window.AMap.plugin(['AMap.Geocoder'], function () {
        geocoder = new window.AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        })
        geocoderRef.current = geocoder
      })

      // POI搜索插件
      window.AMap.plugin('AMap.PlaceSearch', () => {
        let place = new window.AMap.PlaceSearch({})
        // 选择地点
        window.AMap.event.addListener(auto, 'select', (e) => {
          place.search(e.poi.name)
          // 根据经纬度获取地理位置对象
          geocoder.getAddress(e.poi.location, function (status, result) {
            if (status === 'complete' && result.regeocode) {
              setPosition({
                longitude: e.poi.location.lng,
                latitude: e.poi.location.lat
              })
              setZoom(18)
              setSearchContent(e.poi.district + e.poi.address + e.poi.name)
            }
          })
        })
      })

      // 首次进入定位地图
      geocoder.getLocation(searchContent, function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          setPosition({
            longitude: result.geocodes[0].location.lng,
            latitude: result.geocodes[0].location.lat
          })
          setZoom(18)
        } else {
          setZoom(18)
        }
      })
    },
    click: (e) => {
      if (geocoderRef.current) {
        geocoderRef.current.getAddress(e.lnglat, function (status, result) {
          if (status === 'complete' && result.regeocode) {
            setSearchContent(result.regeocode.formattedAddress)
            setPosition({ longitude: e.lnglat.lng, latitude: e.lnglat.lat })
            setZoom(18)
          }
        })
      }
    }
  }

  return (
    <div className="amap-wrap">
      <div className="amap-content">
        <div className="amap-left">
          <span>
            <i>*</i>详细地址
          </span>
        </div>
        <div className="amap-right">
          <div className="amap-input">
            <input
              id="search-input"
              onChange={(e) => placeSearch(e.target.value)}
              value={searchContent}
            />
          </div>
          <div id="amap">
            <Map
              amapkey={'348f768eed5b34b13c44ebccc532b7a6'}
              plugins={['ToolBar']}
              events={mapEvents}
              center={position}
              useAMapUI={true}
              zoom={zoom}
            >
              <Marker position={position}>
                <div className="amap-marker"></div>
              </Marker>
            </Map>
          </div>
          <div className="amap-btn">
            <Button
              onClick={() => {
                handleCancel()
              }}
            >
              取消
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (searchContent.trim() === '') {
                  message.warning('地址栏不能为空！')
                  return false
                }
                handleOk(position, searchContent)
              }}
            >
              确定
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Amap }
export default Amap
